/**
 * Download di blob (PDF / XLSX / ZIP) con gestione robusta cross-browser.
 *
 * Bug noto risolto qui: Chrome/Safari processano il click programmatico in modo
 * asincrono. Se revochiamo subito il blob URL (o rimuoviamo l'<a>) il download
 * non parte. Soluzione: ritardare cleanup di 1.5s.
 */
export async function downloadBlob(apiPromise, filename, mime = 'application/octet-stream') {
  const response = await apiPromise;
  if (!response.data || response.data.size === 0) {
    throw new Error('Risposta vuota dal server');
  }
  const blob = new Blob([response.data], { type: mime });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    try { document.body.removeChild(link); } catch { /* already removed */ }
    window.URL.revokeObjectURL(url);
  }, 1500);
}

/** Estrae un messaggio leggibile da un errore Axios anche quando responseType=blob. */
export async function extractAxiosErrorMessage(error) {
  if (error?.response?.data instanceof Blob) {
    try {
      const text = await error.response.data.text();
      const parsed = JSON.parse(text);
      return parsed?.detail || text;
    } catch {
      return error.message || 'Errore sconosciuto';
    }
  }
  return error?.response?.data?.detail || error?.message || 'Errore sconosciuto';
}
